<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
      <v-card-title>Asignar UNDEL</v-card-title>
      <v-card-text>
          <v-row>
              <v-col cols="12" sm="6" md="6">
                    <v-text-field             
                    v-model="camposBD.undel_fecha"
                    label="Fecha Undel"                    
                    type="date"
                    :min="minDate"                    
                    clearable                    
                    ></v-text-field>
                </v-col>
          </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <v-card elevation="10" outlined>
                    <v-card-subtitle>Motivos</v-card-subtitle>
                    <v-card-text>                
                    <v-row>
                        <v-col cols="4" sm="4" md="4">
                            <v-combobox
                                v-model="motivo"
                                :items="motivosLst"
                                item-text="motivo"
                                item-value="id"
                                label="Motivo"
                                clearable
                                append-icon="mdi-clipboard-edit"
                                return-object              
                                ></v-combobox>
                        </v-col>
                        <v-col cols="4" md="4" sm="4">
                            <v-text-field             
                            v-model="observacion"
                            label="Observación"
                            append-icon="mdi-briefcase-search"                                                        
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <v-btn outlined color="primary" @click="addMotivoUndel()">Agregar <v-icon>mdi-arrow-right-bold-circle</v-icon></v-btn>
                        </v-col>
                    </v-row>                    
                    <v-row>
                        <v-col>
                            <v-data-table
                            :headers="headersM"
                            :items="motivosTbl"
                            class="elevation-1"
                            >
                            <template v-slot:item.acciones="{ item }">
                                <v-tooltip bottom color="#96298A">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        icon
                                        color="red"
                                        @click="deleteMotivoUndel(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                        <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                    </v-tooltip>
                            </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    </v-card-text>
                </v-card>
            </v-col>          
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
            v-model="camposBD.undel_solucion"
            label="Solución"
            append-icon="mdi-briefcase-check-outline"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-text-field             
                v-model="camposBD.undel_fechasolucion"
                label="Fecha Solución"
                clearable
                type="date"                
                ></v-text-field>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn color="primary" outlined @click="asignar()"> Guardar <v-icon>mdi-content-save</v-icon></v-btn>
      </v-card-actions>
    </v-card>
      </v-col>
    </v-row>    
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </v-container>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
import moment from 'moment-timezone';
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {
      minDate: null,
      camposBD: {        
        undel_fecha: null,
        undel_solucion: null,
        undel_fechasolucion: null,
      },
      headersM: [
          { text: "Motivo", value: "motivo.motivo"},
          { text: "Observación", value: "observacion"},
          { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      motivosLst: [], 
      motivo:null,
      observacion: null,
      motivosTbl: [],   
      overlay: false,      
    };
  },
  methods: {
    fillMotivosLst:async function () {
      await apicon.getDataApi(apicon.getApiBaseUrl() + "motivoundel").then((result) => {
        this.motivosLst = result;
      });
    },
    fillMotivosGuia:async function(){
        await apicon.getDataApi(apicon.getApiBaseUrl() + 'motivoundelguiabyguia/' + this.id).then((result) => {
            this.motivosTbl = result;
        }); 
    },
    addMotivoUndel: function(){
        //Validar datos
        if(this.motivo != null){
            var datos = {
                id_guia : this.id,
                id_motivo : this.motivo.id,
                observacion : this.observacion
            }
            apicon.saveDataApi(apicon.getApiBaseUrl() + 'motivoundelguia', datos).then((result) => {
                //this.$swal(result.message);
                this.motivo = null;
                this.observacion = null;
                this.fillMotivosGuia();
            });
        }else{
            this.$swal("Por favor seleccione el motivo a agregar");
        }
    },
    deleteMotivoUndel: function(item){
        var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon
            .deleteDataApi(apicon.getApiBaseUrl() + "motivoundelguia/" + item.id)
            .then((result) => {
              self.fillMotivosGuia();
              this.$swal(result.message);
            });
        }
      });
    },
    fillDatosUndel:async function(){
        await apicon.getDataApi(apicon.getApiBaseUrl() + 'guias/' + this.id).then((result) => {
            if(result){
                this.camposBD.undel_fecha = result.undel_fecha;
                this.camposBD.undel_solucion = result.undel_solucion;
                this.camposBD.undel_fechasolucion = result.undel_fechasolucion;
            }
        });
    },
    setFechasUndel:function(){        
        let fechaActual = moment(new Date()).tz(this.timeZone);
        this.minDate = moment(fechaActual).format("YYYY-MM-DD");
        this.camposBD.undel_fecha = this.minDate;
    },
    asignar: async function (id) {
      //if (this.camposBD.undel_fecha != null) {
        this.overlay = true;
        await apicon
          .updateDataApi(apicon.getApiBaseUrl() + "guias/" + this.id,this.camposBD)
          .then((result) => {
            this.overlay = false;            
            this.$swal(result.message);
          });
      /*} else {
        this.$swal("Por favor seleccione la fecha de undel...");
      }*/
    },
  },
  mounted:async function () {
    apicon.setAuthHeaders();
    await this.fillMotivosLst();
    await this.fillMotivosGuia();
    await this.fillDatosUndel(); 
    //await this.setFechasUndel();   
  },
};
</script>